import React from "react";
import { useNavigate } from "react-router-dom";

const PaymentFailure = () => {
  const navigate = useNavigate();

  return (
    <div className="status-container failure">
      <div className="status-card">
        <div className="status-icon">❌</div>
        <h1>Pago no procesado</h1>
        <p>Hubo un problema al intentar realizar el pago.</p>
        <p>Puedes intentarlo de nuevo con otro método de pago.</p>
        
        <button className="status-btn" onClick={() => navigate("/")}>
          Reintentar Compra
        </button>
      </div>
    </div>
  );
};

export default PaymentFailure;